import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ParallaxBg } from "../components/ParallaxBg";

gsap.registerPlugin(ScrollTrigger);

const LINES = [
  { text: "NOT SURE HOW TO USE", style: {} },
  { text: "YOUR VA LOAN?", style: { color: "#3D7BFF" } },
  { text: "I'LL SHOW YOU HOW TO USE", style: { opacity: 0.28 } },
  { text: "IT TO YOUR ADVANTAGE.", style: {} },
];

export default function Manifesto() {
  const ref = useRef(null);

  useEffect(() => {
    const words = ref.current.querySelectorAll(".manifesto-word");
    const tween = gsap.to(words, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      ease: "power2.out",
      stagger: 0.04,
      scrollTrigger: { trigger: ref.current, start: "top 72%" },
    });
    return () => { tween.scrollTrigger?.kill(); tween.kill(); };
  }, []);

  const scrollToRegister = () => {
    const el = document.getElementById("register");
    if (window.__lenis) window.__lenis.scrollTo(el, { duration: 1.4 });
    else el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section ref={ref} className="relative overflow-hidden py-28 md:py-40" data-testid="manifesto-section">
      <ParallaxBg image="/bg/home2.jpg" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-[1fr_auto] gap-16 items-start">
        <div>
          <p className="section-label mb-10">[001] — THE PROBLEM</p>
          <h2 className="manifesto-statement mb-10" data-testid="manifesto-statement">
            {LINES.map((line, li) => (
              <span key={li} className="block">
                {line.text.split(" ").map((w, wi) => (
                  <span key={wi} className="manifesto-word mr-[0.22em]" style={line.style}>{w}</span>
                ))}
              </span>
            ))}
          </h2>
          <div style={{ color: "rgba(240,236,228,0.55)", fontSize: 16, lineHeight: 1.75, maxWidth: 560 }} className="mb-10 space-y-5">
            <p>
              The VA loan can be one of the most powerful home financing options available to eligible Veterans, service members, and surviving spouses—but understanding how to use it effectively isn't always simple. How much entitlement you have available, whether you're exempt from the VA funding fee, what to expect for closing costs, how seller concessions may reduce—or in some cases eliminate—what you need to bring to closing, what property requirements to look out for, what effective communication between your Mortgage Loan Advisor and Realtor should actually look like, and how your personal affordability and lender pre-approval affect your buying power can all impact your purchase.
            </p>
            <p>
              In this free webinar, I'll break down the key things you need to understand and prepare for during the VA homebuying process—in plain English—so you can understand your options, ask better questions, and approach your home purchase with greater confidence.
            </p>
          </div>
          <button className="btn-outline" data-testid="manifesto-cta" onClick={scrollToRegister}>SEE HOW IT WORKS →</button>
        </div>
        <div className="pixel-grid hidden lg:grid mt-24">
          {Array.from({ length: 64 }).map((_, i) => <span key={i} />)}
        </div>
      </div>
    </section>
  );
}
